import React, { Fragment } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import NewEditor from './TextEditor/NewEditor';
import Loading from './loading';
import PostCard from './PostCard';

const Articles = ({ isLoading, data, currentUser, dispatchPosts, type, socket }) => {

    const visiblePosts = [...data]
        .filter(p => p.type === type && (p.visible || (currentUser.user.isAdmin > 8 && currentUser.adminSettings)))
        .sort((a, b) => (a.order > b.order ? 1 : -1));

    return (
        !isLoading ? (
            <Fragment>
                {visiblePosts.map(p => (
                    <PostCard
                        key={p._id}
                        post={p}
                        siblings={visiblePosts}
                        currentUser={currentUser}
                        dispatchPosts={dispatchPosts}
                        socket={socket}
                    />
                ))}
                {(currentUser.isAuthenticated && currentUser.user.isAdmin > 8 && currentUser.adminSettings) && (
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Card sx={{ textAlign: 'center', cursor: 'pointer', width: '100%' }}>
                            <NewEditor
                                dispatchPosts={dispatchPosts}
                                currentUser={currentUser}
                                type={type}
                                socket={socket}
                            />
                        </Card>
                    </Box>
                )}
            </Fragment>
        ) : (
            <Loading />
        )
    );
};

export default Articles
